import { render, staticRenderFns } from "./edit-register-polite.vue?vue&type=template&id=7f4a0009&scoped=true&"
import script from "./edit-register-polite.vue?vue&type=script&lang=js&"
export * from "./edit-register-polite.vue?vue&type=script&lang=js&"
import style0 from "./edit-register-polite.vue?vue&type=style&index=0&id=7f4a0009&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4a0009",
  null
  
)

export default component.exports